import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'À qui s’adresse cette bibliothèque ?',
  answer: 'Aux praticiens qui utilisent le tarot, le Reiki ou les chakras, seuls ou ensemble, et qui veulent des séances organisées, avec des fiches, des déroulés et des planches prêts à imprimer.'
}, {
  question: 'Faut-il déjà pratiquer les trois ?',
  answer: 'Non. Le guide « Commencez ici » propose un ordre de lecture : chaque volume explique sa pratique pas à pas, puis le Volume 6 les réunit dans la séance intégrée.'
}, {
  question: 'Le tarot sert-il à prédire l’avenir ?',
  answer: 'Non. Le tarot est présenté ici comme un outil de réflexion et de dialogue, selon la tradition du Tarot de Marseille. Aucune carte n’annonce un événement.'
}, {
  question: 'Remplace-t-il un suivi médical ?',
  answer: 'Non. Le tarot, le Reiki et les chakras sont présentés comme des pratiques de bien-être et de réflexion selon les traditions : aucun diagnostic, et rien ne remplace l’avis d’un professionnel de santé. Le guide explique aussi quand orienter la personne vers un médecin.'
}, {
  question: 'Remplace-t-il un stage de Reiki ?',
  answer: 'Non. C’est un support pédagogique : il ne délivre aucun certificat et ne remplace pas l’enseignement d’un enseignant Reiki.'
}, {
  question: 'Peut-on vraiment imprimer les fiches ?',
  answer: 'Oui. Les 60 fiches sont des pages A4 : imprimez-les chez vous ou chez un imprimeur, autant de fois que nécessaire.'
}, {
  question: 'Comment vais-je recevoir la bibliothèque ?',
  answer: 'Juste après le paiement, vous recevez un e-mail avec l’accès à vos fichiers PDF : les 6 volumes, les 60 fiches, le guide « Commencez ici » et les 5 bonus. Téléchargez-les sur votre ordinateur, votre tablette ou votre téléphone.'
}, {
  question: 'Les 5 bonus sont-ils vraiment offerts ?',
  answer: 'Oui. Ils sont inclus avec votre système, sans aucun coût supplémentaire.'
}, {
  question: 'Est-ce un abonnement ?',
  answer: 'Non. C’est un paiement unique, sans abonnement et sans frais cachés.'
}, {
  question: 'Et si j’ai un problème d’accès ?',
  answer: 'Écrivez à defgrup.soporte@gmail.com avec l’adresse e-mail utilisée lors de l’achat. Votre achat est couvert par la protection d’achat de 7 jours décrite plus haut.'
}];
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-55" data-mp="33kli0yn5rme2"><div className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-premium" data-id="element-56" data-mp="2yms8pwqk6c9k"><button className="flex w-full items-center gap-4 p-5 text-left sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-57" data-mp="2ulzyb05ya1bp"><span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-58" data-mp="1n97ovl3dq87z">?</span><span className="flex-1 font-semibold text-navy" data-id="element-59" data-mp="1j501br8nqybc">{item.question}</span><ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-60" data-mp="3uupqczc9y2js" /></button><AnimatePresence initial={false} data-id="element-61" data-mp="2qx8g099qw9z">{open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22
        }} data-id="element-62" data-mp="2nrkwpgag2gd"><p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-63" data-mp="cgp5r28r63i5">{item.answer}</p></motion.div>}</AnimatePresence></div></Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-64" data-mp="mdbnvj9p2ggh"><div className="mx-auto max-w-3xl" data-id="element-65" data-mp="mfxvtk0hyxz8"><Reveal className="text-center" data-id="element-66" data-mp="qfgf6bco70zy"><h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-67" data-mp="qg810uggtkd1">❓ Questions <span className="text-sage" data-id="element-68" data-mp="vf1eimvr5bd7">fréquentes</span></h2><p className="mt-5 text-slate" data-id="element-69" data-mp="vcoyif9k1b2s">Tout ce que vous voulez savoir avant de commander.</p></Reveal><div className="mt-10 space-y-3" data-id="element-70" data-mp="2s8w5f74uidue">{faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-71" data-mp="2x5cwa93fj6b6" data-mpi={index} />)}</div></div></section>;
}